import React, { useId } from "react";
import { cn } from "../../lib/cn";
import { Card } from "./Card";

const TESTIMONIALS = [
  {
    quote:
      "I brought in my Range Rover after the suspension warning came on and the ride started feeling uneven. They diagnosed the issue, explained what was happening clearly, and got the repair handled without making me feel pressured.",
  },
  {
    quote:
      "My BMW had a check engine light and rough idle that another shop couldn't fully figure out. They took the time to inspect it properly, found the issue, and explained the repair in a way that actually made sense.",
  },
  {
    quote:
      "I came in for a smog check and also had them look at my Mercedes because it was leaking coolant. The smog process was quick, and they were able to point out the repair issue before it became worse.",
  },
];

export default function ReviewSection({ className, tone = "light" }) {
  const light = tone === "light";
  const headingId = useId();

  return (
    <section
      className={cn("", className)}
      aria-labelledby={headingId}
    >
      <h2
        id={headingId}
        className={cn(
          "mb-5 text-xl font-semibold sm:text-2xl",
          light ? "text-navy-900" : "text-white",
        )}
      >
        Customer Testimonials
      </h2>
      <ul className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {TESTIMONIALS.map((item, index) => (
          <Card
            key={index}
            as="li"
            interactive
            padding="md"
            className="flex flex-col"
          >
            <p className="flex-1 text-sm leading-relaxed text-slate-700">
              &ldquo;{item.quote}&rdquo;
            </p>
          </Card>
        ))}
      </ul>
    </section>
  );
}
